import { render, staticRenderFns } from "./EmergencyMatterDialog.vue?vue&type=template&id=2c5f0b96&scoped=true"
import script from "./EmergencyMatterDialog.vue?vue&type=script&lang=js"
export * from "./EmergencyMatterDialog.vue?vue&type=script&lang=js"
import style0 from "./EmergencyMatterDialog.vue?vue&type=style&index=0&id=2c5f0b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f0b96",
  null
  
)

export default component.exports